import type { CSSObject } from '@mantine/core';
import type { ThemeComponentType } from '../types';

export const Tabs: ThemeComponentType = {
  defaultProps: {
    variant: 'pills',
  },
  styles: (theme, { variant }) => {
    const styles: Record<string, CSSObject> = {
      tabLabel: {
        fontSize: theme.fontSizes.md,
        lineHeight: '24px',
      },
    };

    switch (variant) {
      case 'pills':
        styles.tab = {
          padding: theme.other.spacing(0.5, 1.5),
          borderWidth: 0,
          fontWeight: 500,
          border: `1px solid ${theme.colors[theme.primaryColor][9]}`,
          color: theme.colors[theme.primaryColor][9],
          opacity: 0.5,
          '&[data-active]': {
            color: '#ffffff',
            backgroundColor: theme.colors[theme.primaryColor][9],
            opacity: 1,
            '&:hover': {
              backgroundColor: theme.colors[theme.primaryColor][9],
            },
          },
          '&:hover': {
            opacity: 1,
            backgroundColor: 'transparent',
          },
          '&:disabled': {
            border: 0,
            opacity: 1,
            '&:hover': {
              color: theme.colors.gray[3],
              backgroundColor: theme.colors.gray[1],
            },
          },
        };
        break;
      case 'default':
        styles.tabsList = { borderColor: theme.colors.gray[1] };
        styles.tab = {
          padding: theme.other.spacing(0.5, 2),
          '&:hover': {
            backgroundColor: 'initial',
          },
          '&[data-active]': {
            color: theme.colors[theme.primaryColor][0],
          },
        };
        styles.tabLabel = {
          ...styles.tabLabel,
          fontWeight: 500,
        };
        break;
      default:
        throw new Error(`Unknown variant: ${variant}`);
    }

    return styles;
  },
};
